export default __webpack_public_path__ + "static/media/policy_brief0.3cd3bea4.png";